export default (payload) => ({
  type: 'SET_DELETE_MODAL',
  payload,
});
